import React, { useState, useRef, useEffect } from "react";
import Button from '@mui/material/Button';
import { Container, Col, Row } from "reactstrap";
import { useNavigate, useLocation, Link } from "react-router-dom";
import logo from '../../../Assets/Images/logo.png';
import TextField from '@mui/material/TextField';
import { useForm } from "react-hook-form";
import { handlingCatchError } from "../../../Utils/ErrorHandling";

import SubscriptionFooter from "../../Common/SubscriptionFooter";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";
import ConstantData from "../../../Utils/Constant";

const BuyMarketReport = (props) => {
  const navigate = useNavigate();
  const { handleSubmit, control, watch, register } = useForm();
  const password = useRef({});
  password.current = watch("password", "");
  const [userDetails, setUserDetails] = React.useState({});
  const [firstNameErr, setFirstNameErr] = React.useState('');
  const [lastNameErr, setLastNameErr] = React.useState('');
  const [emailErr, setEmailErr] = React.useState('');
  const [phoneErr, setPhoneErr] = React.useState('');
  const [isLoading, setLoading] = React.useState(false);
  const [reportDetails, setReportDetails] = React.useState([]);
  const priceDetails = props.packageFullData ? props.packageFullData.filter(data=>data.id === ConstantData.lookupKeyMap.singleReport)[0] : [];

  const search = useLocation().search;
  const sessionId = new URLSearchParams(search).get('sessionid');

  const onChangeValidation = (e) => {
    // First name validation
    if (e.target.name === 'firstName') {
      var regName = /^[A-Za-z\/\s\.'-]+$/;
      var name = e.target.value;
      if (name.length === 0) {
        setFirstNameErr('First name required');
      } else {
        if (!regName.test(name)) {
          setFirstNameErr('Invalid character');
        } else {
          setFirstNameErr('');
        }
      }
    }

    // Last name validation
    if (e.target.name === 'lastName') {
      var regName = /^[A-Za-z\/\s\.'-]+$/;
      var name = e.target.value;
      if (name.length === 0) {
        setLastNameErr('Last name required');
      } else {
        if (!regName.test(name)) {
          setLastNameErr('Invalid character');
        } else {
          setLastNameErr('');
        }
      }
    }

    // Email validation
    if (e.target.name === 'email') {
      var regName = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
      // var regName = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
      var name = e.target.value;
      if (name.length === 0) {
        setEmailErr('Email address required');
      } else {
        if (!regName.test(name)) {
          setEmailErr('Email address is invalid');
        } else {
          setEmailErr('');
        }
      }
    }

    //phone
    if (e.target.name === 'phone') {
      var string = e.target.value;
      var replacedString = e.target.value.replace(/-/g, "").replace("(", "").replace(")", "");
      var spaceRemovedStr = string.replace(/ /g, '');
      var numericRegex = /^([0-9]*)$/;
      var valid = numericRegex.exec(replacedString);

      if (valid) {
        string = replacedString;
        var regex = replacedString.length === 10 ? /^([^\s]{3})([^\s]{3})+([^\s]{4})+$/g : replacedString.length === 11 ? /^([^\s]{3})([^\s]{3})+([^\s]{5})+$/g : replacedString.length === 12 ? /^([^\s]{3})([^\s]{3})+([^\s]{6})+$/g : replacedString.length === 13 ? /^([^\s]{3})([^\s]{3})+([^\s]{7})+$/g : replacedString.length === 14 ? /^([^\s]{3})([^\s]{3})+([^\s]{8})+$/g : replacedString.length === 15 ? /^([^\s]{3})([^\s]{3})+([^\s]{9})+$/g : /^([^\s]{3})([^\s]{3})+([^\s]{9})+$/g;
        var match = regex.exec(string);
        if (match) {
          match.shift();
          match[0] = "(" + match[0] + ")";
          string = match.join("-");
          if (replacedString.length >= 16) {
            setPhoneErr('Invalid number');
          } else {
            setPhoneErr('')
          }
        } else {
          if (replacedString.length >= 16) {
            setPhoneErr('Invalid number');
          } else {
            setPhoneErr('');
          }
        }

      } else if (spaceRemovedStr.length > 0) {
        setPhoneErr('Invalid number');
      }
      if (string === "") {
        setPhoneErr('Phone is required');
      }
    }
    setUserDetails({ ...userDetails, [e.target.name]: e.target.name === 'phone' ? string : e.target.value });

  }

  const formSubmission = () => {
    setLoading(true);
    let inputData={ "FirstName": userDetails.firstName,
        "LastName": userDetails.lastName,
        "Company": userDetails.companyName ? userDetails.companyName : '',
        "EmailAddress": userDetails.email,
        "Phone": userDetails.phone,
        "SessionId": sessionId,
        "lookupkey": priceDetails && priceDetails.lookupkey ? priceDetails.lookupkey : null}
    apiCommonTrigger("post",`${Config.API_URL}/subscription/buymarket`,inputData)
      .then((res) => {
        // return res;
        if (res.status === 200) {
          if (res.data === "success") {
            setLoading(false);
            window.location.replace(res.headers.location);
          }
        }
        else{
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        setLoading(false);
        handlingCatchError(err, navigate);
      })
  }

  // Form submission
  const onHandleSubmit = () => {
    if (!firstNameErr && !lastNameErr && !emailErr && !phoneErr && userDetails.firstName && userDetails.lastName && userDetails.email && userDetails.phone) {
      setLoading(true);
      apiCommonTrigger("get" , Config.API_URL + "/home/validatesignupemail/" , [userDetails.email])
      .then((res) => {
        if (res.status === 200) {
          if (res.data.isexist === false) {
            setLoading(false);
            formSubmission();
          } else {
            setLoading(false);
            setEmailErr('Email already linked to an existing RV Parks account. Please use a different email address.')
          }
        }
        else{
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        setLoading(false);
        handlingCatchError(err, navigate);
      })

    } else {
      if (firstNameErr === '' && !userDetails.firstName) {
        setFirstNameErr('Please fill out this field');
      }
      if (lastNameErr === '' && !userDetails.lastName) {
        setLastNameErr('Please fill out this field');
      }
      if (emailErr === '' && !userDetails.email) {
        setEmailErr('Please fill out this field');
      }
      if (phoneErr === '' && !userDetails.phone) {
        setPhoneErr('Please fill out this field');
      }
    }
  }

  useEffect(() => {
    if (reportDetails.length === 0)
      loadReportDetails();
  }, []);

  const loadReportDetails = () => {
    setLoading(true);
    apiCommonTrigger("get" , Config.API_URL + '/subscription/checkoutmarketdet/' , [sessionId])
    .then((res) => {
      if (res.status === 200) {
        setReportDetails(res.data.marketCartDet);
        setLoading(false);
      }
      else{
        setLoading(false);
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      setLoading(false);
      handlingCatchError(err, navigate);
    })
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="default-page loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      <div className='subscription-wrapper' style={{ position: 'relative', height: '100vh' }}>
        <Container fluid>
          <Row>
            <Col className='part-left' style={{ height: '100vh', maxHeight: '100vh', minHeight: '100vh' }}>
              <Container>
                <Row>
                  <Col xs={12} className='logo-subscription mt-2 text-center'>
                  <Link to={"/"}><img src={logo} alt="RVParkIQ" className='rvparks-logo' /></Link>
                  </Col>

                  <Col xs={12} className="modal-custom-popup mt-2">
                    <form id='RVParkIQ_buy_market_report_form'>
                      <h3 className="text-center">Create Account to Purchase Market Report</h3>
                      <Row className="mt-4">
                        <Col>
                          <TextField
                            label="First Name"
                            id="outlined-required"
                            fullWidth
                            value={userDetails.firstName ? userDetails.firstName : ''}
                            name="firstName"
                            onChange={(e) => onChangeValidation(e)}
                            error={!!firstNameErr}
                            helperText={firstNameErr ? firstNameErr : null}
                            margin="normal"
                            required
                            className="textbox-custom"
                          />
                        </Col>
                        <Col>
                          <TextField
                            label="Last Name"
                            id="outlined-required"
                            fullWidth
                            value={userDetails.lastName ? userDetails.lastName : ''}
                            name="lastName"
                            onChange={(e) => onChangeValidation(e)}
                            error={!!lastNameErr}
                            helperText={lastNameErr ? lastNameErr : null}
                            margin="normal"
                            required
                            className="textbox-custom"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <TextField
                            label="Company Name"
                            id="outlined-required"
                            fullWidth
                            value={userDetails.companyName ? userDetails.companyName : ''}
                            name="companyName"
                            onChange={(e) => onChangeValidation(e)}
                            margin="normal"
                            className="textbox-custom"
                          />
                        </Col>
                        <Col>
                          <TextField
                            label="Email Address"
                            id="outlined-required"
                            fullWidth
                            value={userDetails.email ? userDetails.email : ''}
                            name="email"
                            onChange={(e) => onChangeValidation(e)}
                            error={!!emailErr}
                            helperText={emailErr ? emailErr : null}
                            type="email"
                            margin="normal"
                            required
                            className="textbox-custom"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={6}>
                          <TextField
                            label="Phone Number"
                            id="outlined-password-input"
                            size="normal"
                            margin="normal"
                            fullWidth
                            value={userDetails.phone ? userDetails.phone : ''}
                            name="phone"
                            onChange={(e) => onChangeValidation(e)}
                            error={!!phoneErr}
                            helperText={phoneErr ? phoneErr : null}
                            required
                            className="textbox-custom"
                          // type="number"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} className="text-center mt-3 mb-4">
                          <Button onClick={() => onHandleSubmit()} className="market-btn">Buy Market Report @ <b className="pe-1 ps-1">{priceDetails && priceDetails.price ? priceDetails.currency+priceDetails.price : ''}</b>  Plus Data Access</Button>
                        </Col>
                        <p style={{ fontSize: '11px', textAlign: 'center' }}>By providing your email address and clicking 'Buy Market Report @<b className="pe-1 ps-1">{priceDetails && priceDetails.price ? priceDetails.currency+priceDetails.price: ''}</b>Plus Data Access' above, you agree to RVParkIQ <Link to={"/terms-of-service"} target="_blank">Terms of Service</Link> and <Link to={"/privacy-policy"} target="_blank">Privacy Policy</Link>. You can change your communication preferences anytime.</p>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <SubscriptionFooter/>
                        </Col>
                      </Row>
                    </form>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col className='part-right'>
              <Container>
                <Row>
                  <Col xs={12} className="report-details text-center">
                    <h3>Your Selected Market</h3>
                    <p><b>Market:</b> {reportDetails && reportDetails.address ? reportDetails.address : ''}</p>
                    <p className="mb-0"><b>Distance:</b> {reportDetails && reportDetails.radius ? reportDetails.radius : ''} miles radius.</p>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default BuyMarketReport;